import Yup from '../../../utilities/yupExtensions';

export const clientProfileEntriesValidationSchema = Yup.object().shape({
  clientNumber: Yup.string().min(1).label('EGN / Company number'),
  clientName: Yup.string().min(3).label('Full Name / Company name'),
}).atLeastOneOf(
  ['clientNumber', 'clientName'],
  'At least one of [EGN / Company number], [Full Name / Company name] filters is required',
);



// WEBPACK FOOTER //
// ./src/features/client-profile/validation-schemas/clientProfileEntriesValidationSchema.js